<ion-app>
  <!-- Desde 992 px, la barra lateral fija (`app-side-nav`); por debajo, la barra inferior de
       `TabsPage`. Sin sesión (login, registro, recuperación) no hay barra lateral. -->
  <ion-split-pane contentId="main" when="(min-width: 992px)" [disabled]="!showNav">
    <ion-menu contentId="main" class="side-nav-menu" [disabled]="!showNav" [swipeGesture]="false">
      <app-side-nav [uid]="uid"></app-side-nav>
    </ion-menu>
    <ion-router-outlet id="main"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
